import { VIDEO_CONFIG } from './videoConfig';

// Centralized video tracking configuration
// This now pulls from videoConfig.ts - update URLs there, not here

export const VIDEO_TRACKING = {
  MAIN_ANIMATED_FILM: {
    urlPattern: VIDEO_CONFIG.MAIN_ANIMATED_FILM.urlPattern,
    eventName: VIDEO_CONFIG.MAIN_ANIMATED_FILM.eventName,
    clickEventName: VIDEO_CONFIG.MAIN_ANIMATED_FILM.clickEventName
  },
  PRODUCT_ROBOT_FILM: {
    urlPattern: VIDEO_CONFIG.PRODUCT_ROBOT_FILM.urlPattern,
    eventName: VIDEO_CONFIG.PRODUCT_ROBOT_FILM.eventName,
    clickEventName: VIDEO_CONFIG.PRODUCT_ROBOT_FILM.clickEventName
  }
} as const;

export function getVideoTrackingEvent(videoSrc: string | undefined) {
  if (!videoSrc) return null;

  if (videoSrc.includes(VIDEO_TRACKING.MAIN_ANIMATED_FILM.urlPattern)) {
    return VIDEO_TRACKING.MAIN_ANIMATED_FILM;
  }

  if (videoSrc.includes(VIDEO_TRACKING.PRODUCT_ROBOT_FILM.urlPattern)) {
    return VIDEO_TRACKING.PRODUCT_ROBOT_FILM;
  }

  return null;
}